import { render, staticRenderFns } from "./RendererManagement.vue?vue&type=template&id=0e61dbd2&scoped=true&lang=pug"
import script from "./RendererManagement.vue?vue&type=script&lang=js"
export * from "./RendererManagement.vue?vue&type=script&lang=js"
import style0 from "./RendererManagement.vue?vue&type=style&index=0&id=0e61dbd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e61dbd2",
  null
  
)

export default component.exports